module.exports = {
      id: "olympic-usage",
      viewBox: "0 0 11.388 19.966",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#olympic",
      toString: function () {
        return this.url;
      }
    }